export const normalizeBareColumn = (columnName) =>
    columnName?.replace(/^CDM_[^.]+\./, "") || columnName;

export const isStagingCellWrapper = (value) => (
    value != null && typeof value === "object" && Boolean(value.stagingCellKind)
);

export const getStagingRowColumnValue = (row, columnName) => {
    if (!row) return null;
    const raw = row[columnName] ?? row[`CDM_CustomCSV.${columnName}`];
    if (isStagingCellWrapper(raw)) {
        return raw.displayValue ?? "";
    }
    return raw ?? null;
};

export const getStagingCellDisplayValue = (row, columnName) => {
    const value = getStagingRowColumnValue(row, columnName);
    return value ?? "";
};

export const stagingCellValueGetter = (value) => {
    if (isStagingCellWrapper(value)) {
        return value.displayValue ?? "";
    }
    return value ?? "";
};

export const stagingCellValueSetter = (newValue, row, column) => {
    const field = column.field;
    const current = row[field];
    if (isStagingCellWrapper(current)) {
        return { ...row, [field]: { ...current, displayValue: newValue } };
    }
    return { ...row, [field]: newValue };
};

export const resolveStagingColumnField = (columnHeaders, bareColumnName) => {
    const match = (columnHeaders || []).find((header) => {
        const columnName = header.columnName || header.headerName;
        const bare = columnName?.replace(/^CDM_[^.]+\./, "") || columnName;
        return bare === bareColumnName || columnName === bareColumnName;
    });
    return match?.columnName ?? bareColumnName;
};

export const isStagingSuggestionCellEditable = (params, suggestionCellKeys) => {
    const clbId = params?.row?.CLB_ID ?? params?.row?.clb_id;
    const field = params?.field;
    if (clbId == null || !field) return true;
    const bareColumn = field.replace(/^CDM_[^.]+\./, "");
    return !suggestionCellKeys.has(`${clbId}:${bareColumn}`);
};

export const applyAcceptedRowPatches = (items, acceptedRowPatches) => {
    if (!acceptedRowPatches?.size) return items;
    return items.map((item) => {
        const rowId = String(item.CLB_ID ?? item.clb_id);
        const patch = acceptedRowPatches.get(rowId);
        return patch ? { ...item, ...patch } : item;
    });
};
